define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/modal_error_behavior",
    "backbone.syphon",
], function ($, _, Marionette, ModalErrorBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            modalError: {
                behaviorClass: ModalErrorBehavior
            },
        },

        ui: {
            'terminate_saving_account': '.terminate_saving_account',
            'confirm_termination': '#confirm_termination',
            'hold_on_overlay': '#holdon-overlay',
            'deposit_termination': '#deposit_termination',
            'deposit_termination_completed': '#deposit_termination_completed',
            'status': '#status',
        },

        events: {
            'click @ui.terminate_saving_account': 'get_saving_account_cd',
            'click @ui.confirm_termination': 'initiate_termination',
            'change @ui.status': 'show_hide_savings_account',
        },

        initialize: function () {
            // reload when the user terminate an account to show the actualized list
            $(this.ui.deposit_termination_completed).on('hidden.bs.modal', function () {
                location.reload();
            })
        },

        initiate_termination: function () {
            $(this.ui.deposit_interest).modal('hide');
            $(this.ui.hold_on_overlay).show();

            let that = this;
            $.ajax('/rest_saving_account/deposit_termination', {
                method: "PUT",
                data: {
                    "cd": $(this.ui.confirm_termination).data('cd')
                },
                success: function (data) {
                    $(that.ui.deposit_termination).modal('hide');
                    $(that.ui.hold_on_overlay).hide();
                    $(that.ui.deposit_termination_completed).modal('show');
                },
                error: function (xhr, textStatus, errorThrown) {
                    if (errorThrown === '') return;
                    $(that.ui.deposit_termination).modal('hide');
                    $(that.ui.hold_on_overlay).hide();
                    that.triggerMethod('fillErrorModalContent', xhr.responseJSON);
                    that.triggerMethod('openErrorModal');
                }
            });
        },

        get_saving_account_cd: function(e) {
            let cd = $(e.target).data('cd');
            $(this.ui.confirm_termination).data('cd', cd);
        },

        show_hide_savings_account: function(e) {
            let val = $(e.target).val();
            $('tbody tr[data-status!="' + val + '"]').addClass('hidden');
            $('tbody tr[data-status="' + val + '"]').removeClass('hidden');
        }
    });
});